import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  project_airport_id: any;
  published: string;

  header: string;
  header_malay: string;
  header_mandarin: string;

  short_description: string;
  short_description_malay: string;
  short_description_mandarin: string;
  logo_text: string;
  type: string;
  shop_category: string;
  zone_selection: string;
  parent_id_promo: string;
  levels: string;

  image: string;
  banner_image: string;
  square_image: string;
  logo: string;
}

// edit api call
const fetchPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/geo-location-promotions/${id}`);

  return response?.data[0];
};

const usePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["pageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePageDocumentDetails };
